// import { AppData, AppSetting } from "../settings";
import { bindOptionToSelect } from '../index';

let AppData;

export async function InitDropDown(settings, callback, config) {
    AppData = config;
    AppData.isProduction == false ? console.log(settings) : null;
    let results = await dropDownGenerate(settings, callback);
    return results;
}


function dropDownGenerate(settings, callback) {
    var dropDownKeysData = Object.keys(settings);
    let dropDownData = settings;
    AppData.isProduction == false ? console.log(dropDownKeysData) : null;
    AppData.isProduction == false ? console.log(dropDownData) : null;
    for (let i = 0; i < dropDownKeysData.length; i++) {
        const el = dropDownKeysData[i];
        let options = {
            id: dropDownData[el].id,
            name: dropDownData[el].name,
            class: dropDownData[el].class,
            child: dropDownData[el].child
        }
        let selectElement = createSelectElement(options, callback);
        dropDownData[el].data.length > 0 ? selectElement.disabled = false : selectElement.disabled = true;
        dropDownData[el].element = selectElement;
        addOptionToSelect(dropDownData[el].element, dropDownData[el].placeholder);
        dropDownData[el].data.length > 0 ? bindOptionToSelect(dropDownData[el].element, dropDownData[el].data, 'id', 'value') : null;
    }
    return dropDownData;
}

function addOptionToSelect(el, colTxt) {
    const option = document.createElement('option');
    option.value = "";
    option.text = colTxt;
    el.appendChild(option);
}

export function addLabelForSelect(parent, id, lblTxt) {



    const lbl = document.createElement('label');
    lbl.htmlFor = id;
    lbl.textContent = lblTxt;
    lbl.style.fontWeight = 'bold';
    lbl.style.alignItems = "right";
    
    if (AppData.config.hasOwnProperty("showRegions") && !AppData.config.showRegions || (!AppData.config.hasOwnProperty("showRegions") )) {
        let regionSelect = document.querySelector('#regions');
        regionSelect?.classList.add("hidden");
        if (id == "regions") {
            lbl.classList.add("hidden")
        }
    }
    parent.appendChild(lbl);
}

export function addWraperForSelect(parent, uniqVal) {
    let wraperSelect = document.querySelector(`#wraper-select-${uniqVal}`);
    if (!wraperSelect) {
        wraperSelect = document.createElement('div');
        wraperSelect.id = `wraper-select-${uniqVal}`;
        wraperSelect.className = "wraper-select";
        wraperSelect.style.width = "100%";
        wraperSelect.style.textAlign = "right";
        parent.appendChild(wraperSelect);
    }
    return wraperSelect;
}

function createSelectElement(options, callback) {
    let el = document.createElement('select');
    el.data = options.child || null;
    el.name = options.name || null;
    el.id = options.id || null;
    el.className = options.class || null;
    el.onchange = callback;
    return el;
}

export function selectElementCheckOnData(settings) {
    const keys = Object.keys(settings);
    for (let index = 0; index < keys.length; index++) {
        const el = keys[index];
        if (document.getElementById(el).length > 0) {
            document.getElementById(`#${el}`).disabled = false;
        } else {
            document.getElementById(`#${el}`).disabled = true;
        };
    }
}